module.exports = __webpack_public_path__ + "asset/img/video-placeholder.f6a035c00bb4b7f15dc35b66e8a345f7.png";